import { Box, BoxProps } from "@chakra-ui/react";
import { FiUser } from "react-icons/fi";

export const UserIcon = (props: BoxProps) => {
  return <Box as={FiUser} height="20px" width="20px" {...props} />;
};
